import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { AccessibilityProvider } from "./contexts/AccessibilityContext.tsx";
import { AppInner } from "./App.tsx";
import { captureAttribution } from "./lib/attribution.ts";
import "./index.css";

// Save ad-click parameters (gclid, utm_*) from the landing URL before anything
// else, so a lead sent from any page later can carry them.
captureAttribution();

const root = document.getElementById("root")!;

const tree = (
  <StrictMode>
    <HelmetProvider>
      <AccessibilityProvider>
        <BrowserRouter>
          <AppInner />
        </BrowserRouter>
      </AccessibilityProvider>
    </HelmetProvider>
  </StrictMode>
);

// When the HTML was pre-rendered at build time (production), the #root already
// contains markup — hydrate it. In dev the container is empty — mount fresh.
if (root.hasChildNodes()) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
